import { RefObject } from "react";
import { ConnectedBookingData } from "../../../../features/Booking-Form/typings/connected-bookingData";

const moreChipWidth = 30;
const rawChipWidth = 45;
const letterWidth = 7.35;
const marginBetweenChips = 6;

function estimateColleagueChipWidth(colleague: ConnectedBookingData): number {
  return Math.ceil(
    (colleague.firstName.length + colleague.lastName.length + 1) * letterWidth +
      rawChipWidth +
      marginBetweenChips
  );
}

/**
 * How many colleague chips fit on one line.
 * The "+N" width is kept only while later names still have to be hidden.
 * A name that fits on its own is shown instead of collapsing into "+N".
 */
export const calculateTagLimit = (
  containerRef: RefObject<HTMLDivElement>,
  containerPadding: number,
  selectedColleagueFilter: ConnectedBookingData[],
  setTagLimit: (l: number) => void
) => {
  const containerWidth = containerRef.current?.offsetWidth ?? 0;
  if (containerWidth <= 0) return;

  let availableWidth = containerWidth - containerPadding;
  let tagLimit = 0;

  for (let index = 0; index < selectedColleagueFilter.length; index++) {
    const chipWidth = estimateColleagueChipWidth(selectedColleagueFilter[index]);
    const namesStillHidden = selectedColleagueFilter.length - (index + 1);
    const reservedForMore = namesStillHidden > 0 ? moreChipWidth : 0;
    if (chipWidth + reservedForMore > availableWidth) {
      break;
    }
    availableWidth -= chipWidth;
    tagLimit++;
  }

  setTagLimit(tagLimit);
};
